import moment from 'moment';
import React, { useState, useEffect, Fragment, memo } from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import DataReactTableInvoicesPatient from './DataReactTableInvoicesPatient';
import Spinner from 'react-bootstrap/Spinner';
import { formatNumber } from '../../../../Utils/Money';
import { InvoiceUtils } from '../../../../Billing/InvoiceCustomers/SearchInvoiceCostumers/components/InvoiceUtils';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Modal, FormControl, FormGroup, FormControlLabel, Checkbox, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const InvoicesPatient = ({id_patient = '0'}) => {
    const [load, setLoad] = useState(null);
    const [invoicesData, setInvoicesData] = useState(null);
    const [patient, setPatient] = useState(null);
    const [showPDFInvoice, setShowPDFInvoice] = useState(false);

    useEffect(() => {

        const loadSearchPatient = async () => {
            let dataSend = {
                num_documento: parseInt(id_patient)
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.existe) {
                        //setPatient(data.contenido[0])
                        checkInvoicesPatient(data.contenido[0].id_historia)
                        setPatient(data.contenido[0]);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        const checkInvoicesPatient = async (id_historia) => {
            setLoad(true);
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'facturas/revisar-facturas-paciente?id_historia=' + id_historia, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("FACTURAST", data);
                    if (data?.facturas.length > 0) {
                        //setInvoicesData(data.facturas);
                        filterParticularInvoices(data.facturas);
                    }
                    else {
                        setInvoicesData(null);
                    }
                    setLoad(false);
                })
                .catch((error) => {
                    setLoad(false);
                    console.error('Error:', error);
                });
    
        }
        loadSearchPatient();
    }, [])
    
     //filtra las facturas cuando son de un particular
     const filterParticularInvoices = (wholeInvoice) => {
        let invoices = wholeInvoice.filter((invoice)=> invoice.tipo === 1);
        setInvoicesData(invoices);
    }

    const stateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return 'POR PAGAR';
            } else if (parseInt(stateInvoice) === 2) {
                return 'PAGADA PARCIALMENTE';
            } else if (parseInt(stateInvoice) === 3) {
                return 'PAGADA COMPLETAMENTE';
            } else if (parseInt(stateInvoice) === 4) {
                return 'RETRASADA';
            } else if (parseInt(stateInvoice) === 5) {
                return 'SOBREPAGO';
            }
        } else {
            return 'POR PAGAR';
        }
    }

    const colorStateInvoice = (stateInvoice) => {
        if (stateInvoice !== null) {
            if (parseInt(stateInvoice) === 1) {
                return '#0084CF';
            } else if (parseInt(stateInvoice) === 2) {
                return '#FFA600';
            } else if (parseInt(stateInvoice) === 3) {
                return '#48CF00';
            } else if (parseInt(stateInvoice) === 4) {
                return '#FF2D00';
            } else if (parseInt(stateInvoice) === 5) {
                return '#6B00CF';
            }
        } else {
            return '#0084CF';
        }
    }

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        //setTotalInvoice(total_tercero);
        //return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
        return total_tercero;
    }

    const sumPayments = (payments) => {
        let totalPayments = 0
        if (payments !== null && payments !== undefined) {
            if (payments.length > 0) {
                payments.forEach((pay) => totalPayments += pay.importe)
            }
        }
        return totalPayments
    }

    const printPDFInvoice = async (invoice) => {
        console.log("FAC",invoice);

          if(invoice.factura_salud){
            await printInternalHealthInvoice(invoice, invoice.id_tercero, invoice.num_fac_ter, invoice.folio_nota_credito, invoice.es_factura);
          }else{
            //await printInternalComercialInvoice();
          }
    }

    const printInternalHealthInvoice = async (recibos, id_tercero, num_fac_ter, folio_nota_credito, es_factura) => {
        let InvoiceUt = new InvoiceUtils();
        let idsReceipts = InvoiceUt.extractIdForReceipts(recibos);
        await InvoiceUt.getReceiptsById(idsReceipts, id_tercero, num_fac_ter, folio_nota_credito).then((res) => {
    
          if (res != null) {
            setShowPDFInvoice(true);
            if (res.factura.recibosCaja.length > 1) {
              InvoiceUt.generatePDFPrevisualizationInvoices(res.factura, es_factura);
            } else {
              InvoiceUt.generatePDFPrevisualization(res.factura, es_factura);
            }
          }
          else {
            console.log("Error consultando la Previsualizacion de la Factura");
          }
    
        }).catch((error) => {
          alert('Ha ocurrido un error previsualizando la Factura, es posible que se hallan facturado diferentes contratos');
          setShowPDFInvoice(false);
          console.log(error);
        });
      }


    const reactTableData = {
        tableHeaderData: [{
            Header: 'FACTURA Nro.',
            accessor: 'num_fac_ter',
            //disableGlobalFilter: true,
            width: 200,
            Cell: row => (
                <label style={{cursor:'pointer', color:'#0084CF', textDecoration: 'underline'}} onClick={() => printPDFInvoice(row.row.original)}>
                    {row.value}
                </label>
            )
        },
        {
            Header: 'FECHA EMISIÓN',
            accessor: 'fecha_emision',
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : null}</label>
            )
        },
        {
            Header: 'ESTADO',
            accessor: 'estado_pago',
            Cell: row => (
                <label style={{ color: colorStateInvoice(row.value) }}>{stateInvoice(row.value)}</label>
            )
        },
        {
            Header: 'TOTAL',
            accessor: 'total',
            Cell: row => (
                <label>${formatNumber(calculateTotal(row.row.original))}</label>
            )
        },
        {
            Header: 'PAGADO',
            Cell: row => (
                <label>${formatNumber(sumPayments(row.row.original.pagos))}</label>
            )
        },
        {
            Header: 'PENDIENTE',
            Cell: row => (
                <label>${formatNumber(calculateTotal(row.row.original) - sumPayments(row.row.original.pagos))}</label>
            )
        },
        ],
        tableRowsData: invoicesData
    };

    const LoadInfo = () => {
        return (<DataReactTableInvoicesPatient
            reactTableData={reactTableData}
            /* generateClinicEvent={generateClinicEvent} */
        />)
    }

    return (
        <Fragment>
            <Col md={12} lg={12} xl={12} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <Row>
                        <div className='clinic-history-info'>
                                <div>
                                    <h4><b>FACTURAS</b></h4>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <Col>
                                {
                                    load ?
                                        <div className="text-center">
                                            <Spinner animation="border" style={{ color: '#4ce1b6', marginTop: '2em' }} />
                                        </div>
                                        : invoicesData ?
                                        <LoadInfo />
                                        :
                                        <div className="info-empty-profile">
                                            <h5>No se ha generado aún ninguna Factura</h5>
                                        </div>

                                }
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
            {showPDFInvoice ?
                <Modal
                    open={showPDFInvoice}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                >
                    <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
                        <IconButton style={{ float: 'right' }} onClick={() => {
                            setShowPDFInvoice(false);
                        }}>
                            <CloseIcon />
                        </IconButton>
                        <div className='container-pdfs-modal'>
                            <iframe className='iframe-pdfs' id="pdfV" >
                            </iframe>
                        </div>
                    </div>
                </Modal>
                : null}
        </Fragment>
    )
}

export default memo(InvoicesPatient)